import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
// Importa otros módulos que necesites, por ejemplo, HttpClient para realizar peticiones al backend
import { HttpClient } from '@angular/common/http';
import { catchError, first, map, switchMap, tap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { ApiUrlService } from './api-url.service';
import { LoginRequest, LoginResponse } from '../models/users';
import { StoragePortalService } from './storage-portal.service';
import { Token } from '../models/token';

// Define una interfaz para el usuario o el token


@Injectable({
  providedIn: 'root'
})
export class AuthserviceService {

  private currentTokenSubject: BehaviorSubject<Token | undefined>;
  private currentUserSubject: BehaviorSubject<LoginResponse | undefined>;

  public status() {
    return lastValueFrom(this.http.get<any>(this.UrlApi.statusUserApiEnd));
  }






  constructor(
    private http: HttpClient,
    private router: Router,
    private UrlApi: ApiUrlService,
    private storage: StoragePortalService,
    private messageService: MessageService
  ) {
    const storedUser = this.storage.currentUsuario;
    // Los tokens emitidos por el modelo anterior no contienen roles por código.
    // Se invalidan para forzar una autenticación contra PostgreSQL.
    if (storedUser && !Array.isArray(storedUser.roles)) {
      this.storage.clearCurrentUsuario();
      this.storage.clearToken();
    }
    this.currentTokenSubject = new BehaviorSubject<Token | undefined>(
      this.storage.token ?? undefined
    );
    this.currentUserSubject = new BehaviorSubject<LoginResponse | undefined>(
      this.storage.currentUsuario ?? undefined
    );

  }



  public login(user: LoginRequest) {
      //Antes el método login() hacía 2 llamadas separadas:
      //1- Obtener el token
      //2- Obtener los datos del usuario 
      //Estas no estaban encadenadas, así que podían ejecutarse en paralelo: a veces usuarioValue estaba undefined cuando los guards intentaban usarlo
      //Resultado: tenías que hacer dos clics para que el usuario estuviera correctamente cargado antes de entrar.
      //Después (con switchMap):
      //1- Esperamos a recibir el token antes de lanzar la petición de usuario
      //2- Solo cuando se completa la carga del usuario, se continúa con la navegación
      //Ahora todo sucede de forma sincronizada y fluida en un solo clic
    // this.loadUser(user);
    const form: FormData = new FormData();
    form.append('username', user.usuario);
    form.append('password', user.password);


    return this.http.post<Token>(this.UrlApi.tokenUserApiEnd, form)
      .pipe(tap((token: Token) => {
        this.storage.token = token;
        this.currentTokenSubject.next(token);
     
      }), 
      // Consultar la identidad desde el token recién emitido, sin reenviar la contraseña.
      switchMap(() => this.http.get<LoginResponse>(this.UrlApi.currentUserApiEnd)),
      tap((data) => {
        if (data) {
          this.currentUserSubject.next(data);
          this.storage.currentUsuario = data;
        
        } else {
          this.storage.clearCurrentUsuario();
          this.currentUserSubject.next(undefined);
        }
      }),
      map(() => true),
      catchError(error => {
        this.storage.clearToken();
        this.storage.clearCurrentUsuario();
        this.currentTokenSubject.next(undefined);
        this.currentUserSubject.next(undefined);
        this.messageService.add({
          severity: 'error',
          summary: 'Autenticación',
          detail: this.getLoginErrorMessage(error),
          life: 5000
        });
        return throwError(() => error);
      }),
      first()
    );
  }

  public getLoginErrorMessage(error: { status?: number }): string {
    if (error.status === 401) {
      return 'Nombre de usuario o contraseña incorrectos.';
    }
    if (error.status === 403) {
      return 'Tu usuario no tiene permisos para acceder a la Intranet.';
    }
    if (error.status === 0) {
      return 'No se puede conectar con el servidor. Inténtalo de nuevo en unos instantes.';
    }
    return 'No se ha podido iniciar sesión.';
  }

  private loadUser(user: LoginRequest) {
    lastValueFrom(this.http.post<LoginResponse>(this.UrlApi.loginUserApiEnd, user))
      .then(data => {
        if (data) {
          this.currentUserSubject.next(data);
          this.storage.currentUsuario = data;

        } else {
          this.storage.clearCurrentUsuario();
          this.currentUserSubject.next(undefined);
        }
      })
  }

  onTokenInfoChangerd() {
    return this.currentTokenSubject.asObservable();
  }

  public getUser() {
    return this.currentUserSubject.value;
  }

  public changeOwnPassword(currentPassword: string, newPassword: string) {
    return this.http.post(`${this.UrlApi.currentUserApiEnd}/change-password`, {
      current_password: currentPassword,
      new_password: newPassword
    });
  }

  public clearSession(): void {
    this.storage.clearToken();
    this.storage.clearCurrentUsuario();
    this.currentTokenSubject.next(undefined);
    this.currentUserSubject.next(undefined);
  }


 public get isLoggedIn(): boolean {
  return !!this.storage.token?.access_token;
}


  public get usuarioValue(): LoginResponse | undefined {
    return this.currentUserSubject.value;
  }






  logout(): void {
    this.clearSession();
    this.router.navigateByUrl('/login-portal')
      .then(() => window.location.reload());
  }
}
